import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import { Working } from '@ui/Working';
import ErrorText from '@ui/ErrorText';
import { DescriptionInput } from './styles';

const ScriptSelect = styled.select`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 4px;
  padding: 12px;
  -webkit-appearance: auto !important;
`;

const NO_SELECTION = '';

/**
 * Pure presentational form for improving an existing script. State and the
 * request live in the parent; this only renders fields and reports changes.
 */
export const ImproverForm = ({
  scripts,
  isLoadingScripts,
  selectedId,
  description,
  descriptionError,
  error,
  isImproving,
  onSelectScript,
  onDescriptionChange,
  onSubmit,
}) => {
  if (isLoadingScripts) {
    return <Working message="Loading your agent scripts..." />;
  }

  if (scripts.length === 0) {
    return <Body5 isLowContrast>You don't have any editable agent scripts yet. Generate one first.</Body5>;
  }

  return (
    <Container>
      <Container bottom={8}>
        <Body5 bold>Script to improve</Body5>
      </Container>
      <ScriptSelect value={selectedId} onChange={(e) => onSelectScript(e.target.value)} disabled={isImproving}>
        <option value={NO_SELECTION}>Select a script...</option>
        {scripts.map((script) => (
          <option key={script.id} value={script.id}>
            {script.script_name}
          </option>
        ))}
      </ScriptSelect>

      <Container top={24} bottom={8}>
        <Body5 bold>Describe the changes</Body5>
      </Container>
      <DescriptionInput
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        placeholder="Add a fact-check step before formatting, and make the bear case more conservative."
        disabled={isImproving}
      />
      {descriptionError && (
        <Container top={8}>
          <ErrorText>{descriptionError}</ErrorText>
        </Container>
      )}

      <Container top={16}>
        <Body5 isLowContrast>
          This rewrites the selected script in place. You can revert here until you leave the page.
        </Body5>
      </Container>

      {error && (
        <Container top={8}>
          <ErrorText>{error}</ErrorText>
        </Container>
      )}

      <Container top={32} style={{ textAlign: 'center' }}>
        <FlatButton fullWidth disabled={isImproving || !selectedId} onClick={onSubmit}>
          {isImproving ? 'Improving...' : 'Improve Agent Script'}
        </FlatButton>
      </Container>
    </Container>
  );
};
